import {AxiosError} from 'axios';
import {POST_CREATE_NOTIFICATION_URL} from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {NotificationRecipientSelection} from './usePutEditNotification';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface CreateNotificationRequest {
  title: string;
  message: string;
  ackRequired: boolean;
  sendDate: string;
  notificationType: string;
  recipientSelection: NotificationRecipientSelection;
}

interface CreateNotificationResponse {
  uuid: string;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: CreateNotificationResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCreateNotification = ({onSuccess, onError}: Input) => {
  const postCreateNotification = async (requestData: CreateNotificationRequest) => {
    const res = await axiosClient.post<CreateNotificationResponse>(
        POST_CREATE_NOTIFICATION_URL,
        requestData
    );
    return res.data;
  };

  return useCustomMutation(postCreateNotification, {
    onSuccess,
    onError,
  });
};
